export default __webpack_public_path__ + "static/services_03-86072a4a9fbb6f26b9f6a04ce48d920d.png";